import TmuaLandingPage from './TmuaLandingPage';
export default TmuaLandingPage;
